import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddYurticiCargoAgreementRequest } from '../models/request/yurticiCargoAgreement/AddYurticiCargoAgreementRequest';
import { GetYurticiCargoAgreementListPagingAndFilterRequest } from '../models/request/yurticiCargoAgreement/GetYurticiCargoAgreementListPagingAndFilterRequest';

export class YurticiCargoAgreementService {
    static async getYurticiCargoAgreementList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getYurticiCargoAgreementList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargoAgreement/getYurticiCargoAgreementList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportYurticiCargoAgreementList(inputObj: GetYurticiCargoAgreementListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportYurticiCargoAgreementList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargoAgreement/exportYurticiCargoAgreementList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getYurticiCargoAgreementListPagingAndFilter(inputObj: GetYurticiCargoAgreementListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetYurticiCargoAgreementListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargoAgreement/GetYurticiCargoAgreementListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addYurticiCargoAgreement(inputObj: AddYurticiCargoAgreementRequest) {
        try {
            console.log('SERVICE CALL - AddYurticiCargoAgreement', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargoAgreement/AddYurticiCargoAgreement', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteYurticiCargoAgreement(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteYurticiCargoAgreement', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargoAgreement/deleteYurticiCargoAgreement', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getYurticiCargoAgreementById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getYurticiCargoAgreementById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargoAgreement/getYurticiCargoAgreementById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}